import { ChangeDetectionStrategy, Component, computed, inject, input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ApContentService } from '@ap/content';

import content from './message-message.content.json';

@Component({
    selector: 'message-message',
    templateUrl: './message-message.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageMessageComponent {
    private readonly apContentService = inject(ApContentService);
    private readonly sanitizer = inject(DomSanitizer);

    public readonly agentOrBot = input<string>('bot');
    public readonly fromClient = input<boolean>(false);
    public readonly isMessagePending = input<boolean>(true);
    public readonly occurredAt = input<number>(0);
    public readonly showAvatar = input<boolean>(false);
    public readonly text = input<string>('');

    public readonly determineAvatar = computed(() => {
        return this.agentOrBot() === 'bot' ? 'avatar-bot' : 'avatar-agent';
    });

    public readonly determineAriaLabel = computed(() => {
        if (this.agentOrBot() === 'bot') {
            return this.apContentService.get('conversational.chat.message.message.chatbot');
        }

        if (this.agentOrBot() === 'livechat') {
            return this.apContentService.get('conversational.chat.message.message.agent');
        }

        if (this.fromClient()) {
            return this.apContentService.get('conversational.chat.message.message.own');
        }

        return this.apContentService.get('conversational.chat.message.message.other');
    });

    public readonly sanitizedText = computed(() => {
        return this.sanitizer.sanitize(SecurityContext.HTML, this.text());
    });

    public constructor() {
        this.apContentService.addContentItems(content);
    }
}
